import { UrlObject } from "url";
import React, { FC } from "react";
import styled, { css } from "styled-components";
import { breakPoint } from "~/lib/constants";
import { Project } from "~/models/project";
import { Topic } from "~/models/topic";
import { LayoutSize } from "faqSrc/components/layout/Layout";
import RecruitmentButton from "faqSrc/components/modules/header/recruitmentButton";
import HeaderSearch from "faqSrc/components/modules/search/headerSearch";
import LogoAndMultiTitle from "./logoAndMultiTitle";
import LogoAndTitle from "./logoAndTitle";

interface Props {
  layoutSize?: LayoutSize;
  logoUrl: string;
  mainTitle: string;
  mainTitleUrl: UrlObject;
  showSearch?: boolean;
  subTitle?: string;
  subTitleUrl?: UrlObject;
  project?: Project;
  topic?: Topic;
}

const HeaderSimpleWrap: FC<Props> = ({
  layoutSize,
  logoUrl,
  mainTitle,
  mainTitleUrl,
  showSearch = true,
  subTitle,
  subTitleUrl,
  project,
}) => {
  return (
    <Wrap
      className={layoutSize ? `content-wrap-${layoutSize}` : "content-wrap"}
    >
      <HeaderInner
        id="headerInner"
        $dataShowSearch={showSearch}
        $headerQuestionText={project?.headerQuestionText || undefined}
      >
        <HeaderLogoAndTitle>
          {subTitle ? (
            <LogoAndMultiTitle
              logoUrl={logoUrl}
              mainTitle={mainTitle}
              mainTitleUrl={mainTitleUrl}
              subTitle={subTitle}
              subTitleUrl={subTitleUrl}
            />
          ) : (
            <LogoAndTitle
              title={mainTitle}
              titleUrl={mainTitleUrl}
              logoUrl={logoUrl}
              project={project}
            />
          )}
        </HeaderLogoAndTitle>
        {showSearch && project?.headerQuestionText && (
          <HeaderRecruitmentButton>
            <RecruitmentButton project={project} />
          </HeaderRecruitmentButton>
        )}
        {showSearch && <HeaderSearch />}
      </HeaderInner>
    </Wrap>
  );
};

const Wrap = styled.div`
  width: 100%;
`;
const HeaderLogoAndTitle = styled.div``;
const HeaderRecruitmentButton = styled.div``;

const headerWithSearchStyle = css`
  align-items: center;
  display: grid;
  grid-template-columns: auto 28px;
  gap: 12px;

  @media only screen and (max-width: ${breakPoint["sm"]}) {
    grid-template-columns: auto 28px;
  }

  &.has-search {
    grid-template-columns: auto 280px;
    gap: 16px;

    @media only screen and (max-width: ${breakPoint["sm"]}) {
      grid-template-columns: auto;
      gap: 12px;

      ${HeaderLogoAndTitle} {
        display: none;
      }
    }
  }
`;

const headerFAQWithSearchStyle = css`
  align-items: center;
  display: grid;
  grid-template-columns: auto 140px 28px;
  gap: 12px;

  @media only screen and (max-width: ${breakPoint["sm"]}) {
    grid-template-columns: auto 136px 28px;
  }

  &.has-search {
    grid-template-columns: auto 148px 280px;
    gap: 16px;

    @media only screen and (max-width: ${breakPoint["sm"]}) {
      grid-template-columns: auto;
      gap: 12px;

      ${HeaderLogoAndTitle} {
        display: none;
      }

      ${HeaderRecruitmentButton} {
        display: none;
      }
    }
  }
`;

const HeaderInner = styled.div<{
  $dataShowSearch?: boolean;
  $headerQuestionText?: string;
}>`
  ${(props) => {
    if (props.$dataShowSearch && props.$headerQuestionText) {
      return headerFAQWithSearchStyle;
    } else if (props.$dataShowSearch) {
      return headerWithSearchStyle;
    }
    return "";
  }}
`;

export default HeaderSimpleWrap;
